"use client";

import Image from "next/image";
import { Tooltip as ReactTooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";

export default function UseCaseSystem() {
    return (
        <div className="bg-bluebirdlightblue">
            <h1 className="text-4xl p-4 pl-12">Use Case System</h1>
            <p className="pl-12 pr-12 pb-4">
                The BlueBird use case system is organized along <strong>both energy sectors</strong>, including different types of equipment and appliances, and functionalities. 
                The functionalities are clustered into a set of <strong>high level use cases</strong> that include services which can be chosen as components based on the specific situations at a pilot site.
            </p>
            <div className="relative w-full max-w-4xl mx-auto">
                {/* Wrapper for Image and Hotspots */}
                <div className="relative w-full /*aspect-[3/2]*/">
                    {/* Main figure */}
                    <Image
                        src="/projectoverview/usecasesystemnew.png"
                        alt="Use Case System"
                        width={900}
                        height={400}
                        className="object-cover"
                    />

                    {/* --- Hotspot 1: Digital twins --- */}
                    <div
                        data-tooltip-id="research-tooltip"
                        data-tooltip-html="Next state energy demand forecast based on external conditions and asset model"
                        className="absolute top-[88.5%] left-[27%] w-[43%] h-[9%] /*bg-red-500/40 hover:bg-blue-500/40*/ cursor-pointer z-10"
                    />

                    {/* --- Hotspot 2: Optimization --- */}
                    <div
                        data-tooltip-id="empowerment-tooltip"
                        data-tooltip-html="Optimization of the flexible assets in an integrated way (across energy vectors),<br \> or for a specific energy vector (silo perspective).<br \> Optimization can be:
                                            <ul>
                                                <li>o Fully automatic (MPC approach)</li>
                                                <li>o Semi-automatic, where a technical manager has to acknowledge a control action</li>
                                                <li>o Manual, where a recommendation for behaviour change is generated towards end users </li>
                                            </ul>"
                        className="absolute top-[60.5%] left-[20%] w-[58%] h-[24%] /*bg-red-500/40 hover:bg-blue-500/40*/ cursor-pointer z-10"
                    />

                    {/* --- Hotspot 3: User interaction --- */}
                    <div
                        data-tooltip-id="user-interaction-tooltip"
                        data-tooltip-html="Provide recommendations to end users that <br />effectively encourage them to implement<br /> the proposed behavioral changes."
                        className="absolute top-[35%] left-[72%] w-[25%] h-[10%] /*bg-red-500/40 hover:bg-blue-500/40*/ cursor-pointer z-10"
                    />

                    {/* --- Hotspot 4: Market interaction --- */}
                    <div
                        data-tooltip-id="market-interaction-tooltip"
                        data-tooltip-html="Benefit analysis of valorizing the unlocked flexibility potential<br /> across different energy markets, combined with a technical<br /> validation of flexibility activation through the DSO interface."
                        className="absolute top-[24%] left-[27%] w-[43%] h-[24%] /*bg-red-500/40 hover:bg-blue-500/40*/ cursor-pointer z-10"
                    />

                    {/* --- Hotspot 5: Grid extension --- */}
                    <div
                        data-tooltip-id="grid-extension-tooltip"
                        data-tooltip-html="Understanding the potential extensions<br /> of the consumer basis for a given grid."
                        className="absolute top-[35%] left-[5.5%] w-[19%] h-[10%] /*bg-red-500/40 hover:bg-blue-500/40*/ cursor-pointer z-10"
                    />

                    {/* --- Hotspot 6: Impact analysis --- */}
                    <div
                        data-tooltip-id="impact-analysis-tooltip"
                        data-tooltip-html="Assess the optimization based on technical, economic, and social KPIs."
                        className="absolute top-[53%] left-[23%] w-[52%] h-[7%] /*bg-red-500/40 hover:bg-blue-500/40*/ cursor-pointer z-10"
                    />

                </div>

                {/* Tooltips */}
                <ReactTooltip id="research-tooltip" place="top" className="!bg-bluebirdyellow !text-black !rounded-md !opacity-100" />
                <ReactTooltip id="empowerment-tooltip" place="top" className="!bg-bluebirdyellow !text-black !rounded-md !opacity-100" />
                <ReactTooltip id="user-interaction-tooltip" place="top" className="!bg-bluebirdyellow !text-black !rounded-md !opacity-100" />
                <ReactTooltip id="market-interaction-tooltip" place="top" className="!bg-bluebirdyellow !text-black !rounded-md !opacity-100" />
                <ReactTooltip id="grid-extension-tooltip" place="top" className="!bg-bluebirdyellow !text-black !rounded-md !opacity-100" />
                <ReactTooltip id="impact-analysis-tooltip" place="top" className="!bg-bluebirdyellow !text-black !rounded-md !opacity-100" />

                <p className="text-right text-sm mb-4 mt-4 italic">
                    💡 Hover over the different components for more information
                </p>
            </div>
        </div>
    )
}